<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRiChengList"
      data-title="日程信息"
    >
      <el-button
        type="primary"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新增日程
      </el-button>
    </div>
    <div class="content c-table-box mt-2 rounded-lg overflow-y-auto">
      <div
        class="bg-white p-4 rounded-lg mb-3 flex items-center gap-x-3"
        v-for="item in state.list_data"
        :key="item"
      >
        <div class="flex-1">
          <div
            class="flex items-center gap-x-2 text-green-700 cursor-pointer hover:underline"
            @click="
              $openMenu({
                path: 'HuiYiDetailRiChengDetail',
                title: '日程详情-' + item.number,
                refresh: true,
                data: {
                  id: item.id,
                },
              })
            "
          >
            <strong>{{ item.name }}</strong>
          </div>
          <ul class="flex items-center gap-x-2 mt-2">
            <text class="text-gray-700 text-sm">{{ item.sj }}</text>
            <text class="text-gray-400 text-xs">{{ item.rq }}</text>
          </ul>
        </div>
        <el-button type="danger" plain link icon="close"> </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  setup() {
    const state = reactive({});
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      state.list_data = [
        {
          name: "报到注册",
          sj: "10:00 ~ 12:00",
          rq: "2025-12-21",
          id: 1,
        },
        {
          name: "临床需求驱动的红细胞疾病学科创新临床研究",
          sj: "10:00 ~ 12:00",
          rq: "2025-12-21",
          id: 2,
        },
        {
          name: "凝聚一堂-造血干细胞移植沙龙会（合肥站）",
          sj: "10:00 ~ 12:00",
          rq: "2025-12-21",
          id: 3,
        },
      ];
    };
    return { state };
  },
};
</script>

<style lang="less" scoped></style>
